import { isMobile, useMobileOrientation } from 'react-device-detect';
import {
    Box,
    Typography,
    // TextField as TextFieldMui,
} from '@mui/material';
import {
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Divider,
} from '@material-ui/core';

import useDetectKeyboardOpen from "use-detect-keyboard-open";
import { RecordContextProvider } from 'react-admin';

export const Aside = (props) => {
    const { isLandscape } = useMobileOrientation()
    const isKeyboardOpen = useDetectKeyboardOpen();

    return (
        <div style={{ margin: '1em', overflow: 'auto', height: "700px", borderTopWidth: "3px", borderBottomWidth: "3px" }}>
            {((isMobile && isLandscape && !isKeyboardOpen) || !isMobile) ? (

                <Box sx={{ width: '100%', height: "40px", }}>
                    <Typography variant="h6"></Typography>
                    <Stepper orientation="vertical" >
                        {


                            (props.record && props.record.comments) ? props.record.comments.map((his, i) => (


                                <Step expanded active completed >
                                    <StepLabel>
                                        <div>

                                            {new Date(his.createdAt).toLocaleString("fa", { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', })}
                                        </div>
                                        <div>
                                            تغییر توسط :
                                            {his.commentBy?.name}
                                        </div>
                                        {(his.content) ? (
                                            <div>

                                                <div>
                                                    کامنت  :

                                                </div>
                                                <div><p style={{ "white-space": "pre-wrap", "overflow-wrap": "break-word", "inline-size": "250px" }}>{his.content}</p></div>
                                            </div>

                                        ) : null}
                                        <Divider></Divider>

                                    </StepLabel>
                                    <StepContent>
                                        <RecordContextProvider value="تغییر داده شده">
                                        </RecordContextProvider>
                                    </StepContent>
                                </Step>
                            )) : null
                        }
                    </Stepper>
                </Box>
            ) : (
                <Box></Box>
            )}
        </div>
    )
}